import React from "react";
import PhoneInput from "react-phone-input-2";
import { Col, Form, Input, Row, Select } from "antd";
import parsePhoneNumberFromString from "libphonenumber-js";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../../utils/enums";

const ProfileInformationSection = () => {
   return (
      <>
         <div className="mt-8 mb-5">
            <h4>Personal information</h4>
         </div>
         <Row gutter={24}>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="userFullName"
                  label={<span className="label-text required">Full Name</span>}
                  rules={[{ required: true, message: "Please enter your fullname" }]}
               >
                  <Input placeholder="Fullname" />
               </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
               <Form.Item
                  name="userRoleWithinOrganization"
                  label={<span className="label-text">Role within Organization</span>}
               >
                  <Input disabled placeholder="Specify your role..." />
               </Form.Item>
            </Col>
            {!AuthService.isAuthorized([UserRolesEnum.Organization]) && (
               <Col xs={24} sm={12}>
                  <Form.Item name="gender" label={<span className="label-text">Gender</span>}>
                     <Select
                        placeholder="Select an option"
                        options={[
                           {
                              value: "Male",
                              label: "Male"
                           },
                           {
                              value: "Female",
                              label: "Female"
                           },
                           {
                              value: "Other",
                              label: "Other"
                           }
                        ]}
                     />
                  </Form.Item>
               </Col>
            )}
            <Col xs={24} sm={12}>
               <Form.Item
                  label={<span className="label-text required">Phone number</span>}
                  name="userPhoneNumber"
                  rules={[
                     {
                        required: true,
                        message: "This field is required"
                     },
                     () => ({
                        validator(_, value) {
                           if (!value) {
                              return Promise.resolve();
                           }
                           const formatted = value.startsWith("+") ? value : "+" + value;
                           const phoneNumber = parsePhoneNumberFromString(formatted, "US");
                           if (!phoneNumber || !phoneNumber.isValid()) {
                              return Promise.reject(new Error("Invalid phone number"));
                           }
                           return Promise.resolve();
                        }
                     })
                  ]}
               >
                  <PhoneInput />
               </Form.Item>
            </Col>
         </Row>
      </>
   );
};

export default ProfileInformationSection;
